"use client";

import React from "react";
import { Button } from "@heroui/react";
import { Icon } from "@iconify/react";

interface DashboardErrorProps {
  /** Optional callback to retry loading the dashboard */
  onRetry?: () => void;
  /** Custom error message */
  message?: string;
}

/**
 * Error state component for dashboard embedding.
 * Displays an error icon with message and optional retry button.
 */
export const DashboardError: React.FC<DashboardErrorProps> = ({
  onRetry,
  message = "Failed to load dashboard",
}) => (
  <div className="flex flex-col items-center justify-center h-full gap-4">
    <Icon className="text-danger" icon="solar:danger-triangle-outline" width={48} />
    <p className="text-danger text-lg">{message}</p>
    <p className="text-default-500 text-sm">Please check your connection and try again.</p>
    {onRetry && (
      <Button className="btn-brand-primary" onPress={onRetry}>
        <Icon icon="solar:refresh-outline" width={20} />
        Retry
      </Button>
    )}
  </div>
);
